import { useCallback } from 'react';

import { apiDeleteWord } from 'core/api';

export default function useWordsApi(
  setWords: (fn: (prev: TWord[]) => TWord[]) => void
) {
  const onChangeWord = useCallback((updWord: TWord) => {
    setWords(prevWords =>
      prevWords.map(word => (word.uid === updWord.uid ? updWord : word))
    );
  }, []);

  const onAddWord = useCallback((addWord: TWord) => {
    setWords(prevWords => [addWord, ...prevWords]);
  }, []);

  const onRemoveWord = useCallback(async (wordUid: string) => {
    await apiDeleteWord(wordUid);
    setWords(prevWords => prevWords.filter(word => word.uid !== wordUid));
  }, []);

  return { onChangeWord, onAddWord, onRemoveWord };
}
